// Acha a regra de compra (unidade + mínimo opcional) aplicável a um tecido dentro de um
// Fornecedor: um grupo específico que contenha o tecido vence sobre a entrada "todos os
// tecidos" (fallback geral). Sem nenhuma entrada aplicável, não existe regra pra essa
// combinação. Mesma lógica espelhada no backend em helpers/resolveClothPurchaseRule.js
// (o backend nunca confia no que o frontend calculou, resolve de novo server-side).
export default function findClothPurchaseRule(provider, clothId) {
    const rules = provider?.clothPurchaseRules || []
    const groupMatch = rules.find((r) => r.scope === 'group' && (r.cloths || []).some((c) => (c._id || c) === clothId))
    return groupMatch || rules.find((r) => r.scope === 'all') || null
}
